import { User } from "../types/hospital";
import { api } from "./paths";
import axios, { AxiosResponse } from "axios";
import { UserDetails } from "../types";

export async function getUserDetails(): Promise<AxiosResponse<UserDetails>> {
  return await axios.get(api.USERDETAILS_URL);
}

export async function executeFormLoginAuthentication(
  email: string,
  password: string
) {
  const formBody = new FormData();
  formBody.set("username", email);
  formBody.set("password", password);
  return await axios.post(api.LOGIN_URL, formBody, {
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  });
}

export async function getNurseUsersByHospitalId(id: number) {
  return axios.get(`${api.USERS_URL}/hospitals/${id}/nurse-users`);
}

export async function deactivateUserById(id: number) {
  return axios.put(`${api.USERS_URL}/${id}/deactivate-user`);
}

export async function reactivateUserById(id: number) {
  return axios.put(`${api.USERS_URL}/${id}/reactivate-user`);
}

export async function createUser(user: User) {
  return axios.post(api.USERS_URL, user);
}

export async function updateUser(user: User) {
  return axios.put(`${api.USERS_URL}/${user.id}`, user);
}

export async function getAllRodaUsers() {
  return axios.get(`${api.USERS_URL}/roda-users`);
}
